import { SelectChangeEvent } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { FilterProvider } from "../filters/filter-context";
import FullTimeShifts from "../full-time-shifts";
import {
  resetShiftsMeta,
  setSelectedLocation as setShiftSelectedLocation
} from "../full-time-shifts/store/full-time-shifts-slice";
import WorkerScheduler from "../full-time-worker-scheduler";
import { SHIFTS, WORKERS } from "./constants";
import FullTimeSchedulerHeader from "./header";

const SchedulerTabs = () => {
	const currentUserId = useSelector((state: any) => state.user?.userData?.id);

	const dispatch = useDispatch();
	const [activeTab, setActiveTab] = useState(SHIFTS);

	const selectedLocation = useSelector(
		(state: any) => state.fullTimeShifts.selectedLocation
	);

	const allLocations = useSelector(
		(state: any) => state.fullTimeShifts?.filterData?.allLocations
	);

	const locationsWithFTSEnabled = useSelector(
		(state: any) => state.user?.userData?.ftSchedulerEnabledLocations
	);

	const ftSchedulerEnabledLocations = allLocations.filter(
		(location: { id: number }) => locationsWithFTSEnabled.includes(location.id)
	);

	const handleLocationChange = (
		event: SelectChangeEvent<{ value: string }>
	) => {
		dispatch(setShiftSelectedLocation(Number(event.target.value)));
	};

  useEffect(() => {
    if (activeTab === WORKERS) {
      // Reset Shifts Meta when switching to Workers tab
      dispatch(resetShiftsMeta());
    }
  }, [activeTab, dispatch]);

  useEffect(() => {
    try {
      if (ftSchedulerEnabledLocations.length > 0) {
        if (!ftSchedulerEnabledLocations?.map(
          (location: { id: number }) => location.id
        ).includes(selectedLocation)) {
          // Reset selected location to the first available location on refresh
          // If due to cache selected location is having wrong value
          const singleLocation = ftSchedulerEnabledLocations[0];
          dispatch(setShiftSelectedLocation(singleLocation.id));
        }
      }
    } catch (e) {
      // Do nothing
    }
  }, [dispatch, ftSchedulerEnabledLocations, selectedLocation]);

	return (
		<Box sx={{ display: "flex", flexDirection: "column", height: "100%",overflow:"visible" }}>
			<FullTimeSchedulerHeader
				activeTab={activeTab}
				setActiveTab={setActiveTab}
				selectedLocation={selectedLocation}
				handleLocationChange={handleLocationChange}
        allLocations={allLocations}
        ftSchedulerEnabledLocations={ftSchedulerEnabledLocations}
			/>
			<Box sx={{ display: "flex", flexDirection: "row", height: "100%", overflow:"visible" }}>
				{activeTab === WORKERS && (
					<FilterProvider filterKey={`worker-scheduler-${currentUserId}`}>
						<WorkerScheduler />
					</FilterProvider>
				)}
				{activeTab === SHIFTS && (
          <FilterProvider filterKey={`full-time-scheduler-${currentUserId}`}>
            <FullTimeShifts />
          </FilterProvider>
				)}
			</Box>
		</Box>
	);
};

export default SchedulerTabs;
